// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1Koth","title":"Info_title__18-TL","selects":"Info_selects__32wnX","requiredAsterisk":"Info_requiredAsterisk__7BeuN"};